import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner, SpinnerSize } from "@fluentui/react";
import ManagementAuthorizationContract from "@/components/ManagementAuthorization/ManagementAuthorizationContract";
import savingsPlans from "@/services/SavingsPlanService";
import { useContractStepGuard } from "@/screen/ContractManagement/hooks/useContractStepGuard";
import { buildMapNavigationState } from "@/screen/Map/resolveContractOnboardingStepNavigation";

/**
 * Paso 2.2.3 — lectura del poder / solicitar firma (flujo de contrato).
 * Reutiliza el componente legacy con rutas del nuevo mapa.
 */
const ContractManagementAuthorizationScreen: React.FC = () =>
{
    const { savingsPlanId } = useParams<{ savingsPlanId: string }>();
    const guard = useContractStepGuard(Number(savingsPlanId), ["2.2.3", "2.4.4"]);
    const [savingsPlanName, setSavingsPlanName] = useState<string | undefined>(undefined);

    // Cargamos el nombre del plan para que, al volver al mapa, el título muestre el plan
    // correcto. Si no se puede resolver, se deja undefined y el mapa muestra "Mapa de
    // Configuración" a secas (sin arriesgar el nombre de otro plan).
    useEffect(() =>
    {
        let cancelled = false;

        savingsPlans.getSavingsPlan(Number(savingsPlanId)).then((plan) =>
        {
            if(!cancelled)
            {
                setSavingsPlanName(plan?.name);
            }
        })
        .catch(() =>
        {
            // Nombre no resoluble: el mapa usará su título genérico.
        });

        return () =>
        {
            cancelled = true;
        };
    }, [savingsPlanId]);

    if(guard.isChecking)
    {
        return (
            <Spinner size={SpinnerSize.large} style={{marginTop: "2rem"}} />
        );
    }

    return (
        <ManagementAuthorizationContract
            confirmPath={`/contract/${savingsPlanId}/authorization/confirm`}
            backPath="/configurationMap"
            backState={buildMapNavigationState(Number(savingsPlanId), savingsPlanName)}
        />
    );
};

export default ContractManagementAuthorizationScreen;